// extracted by mini-css-extract-plugin
module.exports = {"box":"Footer_box_3wd4E","logo":"Footer_logo_1uqjk"};